import styled from 'styled-components'
import {Link} from 'react-router-dom'

// VideoCard styles for GamingVideoItem
export const NavLink = styled(Link)`
  color: #1e293b;
  text-decoration: none;
`

export const VideoCardContainer = styled.div`
  background-color: #f9f9f9;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.05);
  }
`

export const ThumbnailImage = styled.img`
  width: 100%;
  height: auto;
`

export const VideoDetailsContainer = styled.div`
  padding: 10px;
`

export const VideoDetailsText = styled.p`
  color: ${props => props.textColor || '#1e293b'};
  margin: 5px 0;
`

export const VideoCardBottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
